<template>
  <!--商品详情页面-->
  <tk-container
    :status="status"
    :probeType="3"
    infiniteScroll
    hide-status-bar
    @refresh="refreshInit"
    @scroll="watchScroll"
    ref="resetInfiniteScrollCar"
    @loadingMore="recommendedProducts"
  >
    <!--头部-->
    <gradient-header slot="header" :z-index="zIndex" :is-show-back="true" :is-header-color="isHeaderColor" :back-style="!isHeaderColor" :icon-name="'return'">
      <div slot="center-menu" :style="{color: isHeaderColor ? '#000000' : '#fff'}">商品详情</div>
      <!--收藏-->
      <div slot="right-menu" v-if="isFactoryAccount">
        <tkui-button class="icon flex-icon" @click.native="favoriteProduct">
          <tk-icon size="18" v-if="judgeCollection" :color="'#ffff00'">yishoucang</tk-icon>
          <tk-icon size="18" v-else :color="'#fff'">mycollection</tk-icon>
        </tkui-button>
      </div>
    </gradient-header>
    <!--商品轮播图-->
    <merchandise-carousel v-if="commodity" :width="100" :height="375" :commodity-image="commodity.showPictures"></merchandise-carousel>
    <!--商品价格·标题·卖点·活动入口-->
    <div class="commodity-title" v-if="commodity">
      <tk-flex
        middle
        between
        class="commodity-title-activePrice p-x-12 p-y-5"
        v-if="commodity.typeActivity === 'panicBuying' && judgeTimeRule"
      >
        <tk-flex column>
          <div>限时抢购</div>
          <div class="m-t-5">
            <span class="font-20 font-bold"> <span class="font-10">￥</span>{{commodity.price}}</span>
            <span class="font-12 m-l-5 commodity-title-decoration"> <span class="font-10">￥</span>{{commodity.oldPrice}}</span>
          </div>
        </tk-flex>
        <tk-flex column class="font-12">
          <tk-flex>
            <div>距离结束：</div>
            <count-down :end-time="endTime"></count-down>
          </tk-flex>
          <tk-flex bottom class="m-t-12">
            <div class="font-12 m-r-10">已经抢{{percentage}}%</div>
            <load-progress
              :percent="percentage" :duration="500" :progress-show="true"
              :type="'rect'" :path-colors="['#E83D30', '#fff']"
              :text-color="'rgba(255, 255, 255, 0)'"
              :rect-height="10"
              :rect-width="80"
            ></load-progress>
          </tk-flex>
        </tk-flex>
      </tk-flex>
      <div class="commodity-title-price p-t-5 p-x-12" v-else>
        <div
          class="font-20 class-card-red font-bold"
        >
          <span class="font-10">￥</span>{{commodity.price}}
          <span class="font-12 m-l-5 class-card-decoration caption" v-if="commodity.oldPrice">
             <span class="font-10">￥</span>{{commodity.oldPrice}}
          </span>
        </div>
      </div>
      <!--标题-->
      <!-- <tk-flex
        middle
        class="full-width m-t-5 p-l-12"
      >
        <div
          style="width: 35px;flex-shrink:0;"
        >
          <tk-flex
            center
            v-if="commodity.selfAndSelected"
            style="line-height: 17px;"
            class="commodity-title-label">
            <div>
              {{commodity.selfAndSelected | titleLabel}}
            </div>
          </tk-flex>
        </div>
        <div class="van-ellipsis van-flex-row font-bold">{{commodity.productTitle}}</div>
      </tk-flex> -->
      <tk-flex middle class="full-width m-t-5 p-l-12">
        <div class="van-flex-row font-bold">
          <div style="display:inline-block;position: relative; bottom: 1px" class="full-height">
            <tk-flex
              center
              v-if="commodity.selfAndSelected"
              style="line-height: 17px;"
              class="commodity-title-label">
              <div>
                {{commodity.selfAndSelected | titleLabel}}
              </div>
            </tk-flex>
          </div>
          {{commodity.productTitle}}</div>
      </tk-flex>
      <div class="m-t-5 caption p-x-12 class-card-wrap" v-if="commodity.selling">{{commodity.selling}}</div>
      <tk-flex
        middle
        center
        style="line-height: 1;"
        class="commodity-title-active m-x-12 m-t-5"
        v-if="commodity.typeActivity === 'panicBuying' && judgeTimeRule"
        @click.native="nextLimitedPage"
      >
        限时促销狂欢开启，点击进入 <tk-icon color="rgba(250, 51, 51, 1)" style="height: 9px;" size="8">rightarrow</tk-icon>
      </tk-flex>
      <!--图片-->
      <tk-flex class="full-width b-g-f m-t-5">
        <tk-image
          oraign
          style="width: 100%;height: 50px;"
          :src="'https://s3.moke.cloud/dianpei/e0c94c4c-a381-4d9b-8023-3ed4a4fa5c97.png'"
          height="49"
        ></tk-image>
      </tk-flex>
    </div>
    <!--优惠信息展示-->
    <card
      :width="100"
      :height="20"
      v-if="commodity && commodity.offerContent"
      class="p-12 m-t-10"
    >
      <tk-flex middle class="full-width">
        <div
          class="caption font-14"
          style="flex-shrink: 0;">说明</div>
        <div class="font-14 class-card-wrap text-area-pre" style="margin-left: 15px;">{{commodity.offerContent}}</div>
      </tk-flex>
    </card>
    <!--已选-->
    <div class="b-g-f p-12 m-t-10 commodity-vouchers" v-if="!isFactoryAccount">
      <tk-flex
        between
        middle
        class="full"
        @click.native="selectedShow = true"
      >
        <tk-flex middle gutter="15">
          <div class="caption font-14">已选</div>
          <div class="font-14 font-bold">{{numberOrders + (isTerminalAccount ? '个' : '件')}}</div>
        </tk-flex>
        <tk-icon color="#999" size="12">rightarrow</tk-icon>
      </tk-flex>
    </div>
    <!--配送至地址-->
    <div class="b-g-f p-12 commodity-vouchers" v-if="!isFactoryAccount">
      <tk-flex
        between
        middle
        class="full-width"
        @click.native="$push({ path: '/itsMine/shippingAddress', query: { isSelected: true }})"
      >
        <tk-flex middle class="tk-grid-11">
          <div
            class="caption font-14"
            style="white-space: nowrap;">送至</div>
          <div class="font-14 class-card-ellipsis m-l-12">
            {{selectedAddress ? $tkRegions.getFullName(selectedAddress.region) + selectedAddress.address : '请选择配送地址'}}
          </div>
        </tk-flex>
        <div class="tk-grid-1 text-right">
          <tk-icon color="#999" size="12">rightarrow</tk-icon>
        </div>
      </tk-flex>
    </div>
    <!--服务说明-->
    <tk-flex class="b-g-f p-12 commodity-vouchers">
      <div class="caption font-14" style="width: 46px;">服务</div>
      <tk-flex
        between
        middle
        class="full-width m-t-2"
      >
        <div class="caption font-12">
          <tk-icon size="12" class="m-b-2" color=" rgba(250, 51, 51, 1)">zhengque</tk-icon>
          品质认证
        </div>
        <div class="caption font-12">
          <tk-icon size="12" class="m-b-2" color=" rgba(250, 51, 51, 1)">zhengque</tk-icon>
          联合承保
        </div>
        <div class="caption font-12">
          <tk-icon size="12" class="m-b-2" color=" rgba(250, 51, 51, 1)">zhengque</tk-icon>
          正品保证
        </div>
        <div class="caption font-12">
          <tk-icon size="12" class="m-b-2" color=" rgba(250, 51, 51, 1)">zhengque</tk-icon>
          15天保价
        </div>
      </tk-flex>
    </tk-flex>
    <!--已选弹框-->
    <tk-cover
      :hideOnClick="false"
      :show.sync="selectedShow"
      bottom
      transition
    >
      <div class="selected-style p-15" v-if="commodity">
        <tk-flex between>
          <!--图片·价格-->
          <tk-flex middle>
            <div class="selected-style-image">
              <tk-image :src="commodity.showPictures[0]" height="105" width="105"></tk-image>
            </div>
            <div class="m-l-15">
              <div class="selected-style-price" style="margin-left: -0.5px;">
                <span class="font-10">￥</span>{{commodity.price}}
                <span v-if="commodity.oldPrice" class="font-12 m-l-5 selected-style-decoration caption">
                   <span class="font-10">￥</span>{{commodity.oldPrice}}</span>
              </div>
              <div class="m-t-12 font-13" style="color: #666;">已选：{{numberOrders  + (isTerminalAccount ? '个' : '件')}}</div>
            </div>
          </tk-flex>
          <!--关闭-->
          <div class="selected-style-close" @click="closeSelected">
            <tk-icon size="22" color="#BFBFBF">delete</tk-icon>
          </div>
        </tk-flex>
        <!--计数-->
        <tk-flex middle between class="m-t-15">
          <div class="font-14">数量</div>
          <tk-flex class="selected-style-count">
            <tk-flex
              middle
              center
              class="selected-style-count-left full-height"
              @click.native="countLess"
            >
              <tk-icon size="15" :color="numberOrders === 1 ? '#CACACA' : '#666666'" material>remove</tk-icon>
            </tk-flex>
            <tkui-simple-input
              type="number"
              :disabled="true"
              class="selected-style-count-center"
              v-model="numberOrders"
              mask="natural"
            >
            </tkui-simple-input>
            <tk-flex
              middle
              center
              class="selected-style-count-right full-height"
              @click.native="countAdd">
              <tk-icon size="15" :color="numberOrders === commodity.inventory ? '#CACACA' : '#666666'" material>add</tk-icon>
            </tk-flex>
          </tk-flex>
        </tk-flex>
        <!--确定按钮-->
        <tkui-button
          :disabled="isNothing"
          class="block raised primary rounded m-t-32"
          @click="sureSelected"
        >{{isNothing ? '已抢光' : (selectedTips === 'shoppingCar' ? '加入购物车' : '去结算') }}</tkui-button>
      </div>
    </tk-cover>
    <!--商品详情-->
    <card class="m-t-10 p-0" :width="100" :height="50" v-if="commodity && commodity.IntroductionEvent">
      <div class="p-x-12 p-y-8 font-bold">商品详情</div>
      <div class="commodity-detail-color" v-html="commodity.IntroductionEvent"></div>
    </card>
    <!--底部功能-->
    <card
      slot="footer"
      v-if="!isFactoryAccount"
      :width="100"
      :height="50"
      style="padding: 9px 12px;"
    >
      <tk-flex middle class="full-width">
        <tk-flex between middle class="full tk-grid-5">
          <tk-flex center middle column @click.native="favoriteProduct">
            <tk-icon size="18" v-if="judgeCollection" :color="'#fa3333'">yishoucang</tk-icon>
            <tk-icon size="18" v-else :color="'#000000'">mycollection</tk-icon>
            <div class="m-t-4 font-12" :style="{color: judgeCollection ? '#fa3333' : '#000000'}">收藏</div>
          </tk-flex>
          <tk-flex center middle column @click.native="$push('/common/customerService')">
            <tk-icon size="18">onlineservice</tk-icon>
            <div class="m-t-4 font-12">客服</div>
          </tk-flex>
          <tk-flex center middle column @click.native="goShoppingCar">
            <tkui-badge :value="shoppingCartNum" v-if="shoppingCartNum > 0">
              <tk-icon size="18">shoppingcart</tk-icon>
            </tkui-badge>
            <tk-icon size="18" v-else>shoppingcart</tk-icon>
            <div class="m-t-4 font-12">购物车</div>
          </tk-flex>
        </tk-flex>
        <tk-flex
          middle
          right
          class="font-12 m-l-10 footer-card-btn tk-grid-7"
        >
          <div class="footer-card-btn-lt" @click="shoppingCarBtn">加入购物车</div>
          <div class="footer-card-btn-rt" @click="buyNowBtn">立即购买</div>
        </tk-flex>
      </tk-flex>
    </card>
    <infinite-list :title="'为你推荐'" :infinite-list-pad="'p-x-12'" :products-data="getPriceProcessing(recommendedProductsData, judgeTimeRule)" :color="'#000000'"></infinite-list>
  </tk-container>
</template>

<script>
import merchandiseCarousel from '@/components/merchandiseCarousel'
import loadProgress from '@/components/loadProgress'
import countDown from '@/components/countDown'
import { priceProcessing } from '@/assets/help/tool'
export default {
  components: {
    merchandiseCarousel,
    loadProgress,
    countDown
  },
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      selectedShow: false, // 已选弹框状态
      isHeaderColor: false, // 判断头部颜色切换
      commodity: null, // 商品数据
      collectionDisable: false, // 收藏状态
      fullReduction: null, // 满减
      discount: null, // 折扣
      timeRule: null, // 限时抢购时间
      numberOrders: 1, // 商品计数
      businessData: null, // 商家信息
      shoppingCart: null, // 购物车数据
      selectedAddress: null, // 用户地址
      recommendedProductsData: [], // 为你推荐商品数据获取
      selectedTips: 'shoppingCar' // 弹框按钮提示
    }
  },
  filters: {
    titleLabel (val) {
      return val === 'self' ? '自营' : '精选'
    }
  },
  computed: {
    // 商品id
    commodityId () {
      return this.$route.query.id
    },
    // 加入购物车的商品数量
    shoppingCartNum () {
      if (!this.shoppingCart || (this.shoppingCart && !this.shoppingCart.data)) { return 0 }
      let sum = 0
      this.shoppingCart.data.forEach(s => {
        if (!s.commodityData) { s.commodityData = [] }
        sum += s.commodityData.length
      })
      return sum
    },
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    },
    // 判断是否收藏该商品
    judgeCollection () {
      if (this.commodity && this.commodity.collection && this.commodity.collection.length) {
        return this.commodity.collection.includes(this.userInfo.objectId)
      }
      return false
    },
    endTime () {
      if (!this.timeRule) return ''
      return new Date(this.timeRule.endTime)
    },
    // 计算百分比
    percentage () {
      if (!this.commodity) { return 0 }
      let obj = this.$tkHelper.deepClone(this.commodity)
      if (!obj.sales) { return 0 }
      if (!obj.snappingInventory || !obj.snappingSales) { return 0 }
      let num = obj.snappingSales / obj.snappingInventory
      let percent = Number(Number(num * 100).toFixed(2))
      if (percent > 99.99) { percent = 100 }
      if (percent >= 100) { percent = 100 }
      return percent
    },
    isNothing () {
      return this.percentage >= 100
    },
    // 选择的收货地址id
    addressId () {
      return this.$store.state.addressId
    }
  },
  watch: {
    async addressId () {
      await this.getUserAddress()
    }
  },
  activated () {
    this.$store.commit('setSelectedData', [])
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  methods: {
    /**
    * 初始化数据
    * @date: 2020/3/27
    */
    async getInit () {
      try {
        this.setStatusBar('light')
        if (!this.commodityId || (this.commodityId && !await this.judgeId(this.commodityId, 'commodity'))) {
          this.zIndex = 102
          this.setStatusBar('dark')
          this.status = 'empty'
          return
        }
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        await this.getCommodity() // 获取商品信息
        await this.getShoppingCart() // 获取购物车数据
        await this.getUserAddress() // 获取用户收货地址信息
        if (this.isTerminalAccount) { // 获取商家信息
          this.businessData = await this.$tkParse.getData(`/classes/_User/${(typeof this.userInfo.belongingAccount === 'object') ? this.userInfo.belongingAccount.objectId : this.userInfo.belongingAccount}`)
        } else {
          this.businessData = await this.$tkParse.getData(`/classes/_User/${this.commodity.merchants}`)
        }
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      if (!this.status) { this.setStatusBar(this.isHeaderColor ? 'dark' : 'light') }
      this.$forceUpdate()
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      this.recommendedProductsData = []
      await this.getInit()
      this.$refs.resetInfiniteScrollCar.resetInfiniteScroll()
    },
    /**
    * 获取商品数据
    * @date: 2020/3/27
    */
    async getCommodity () {
      let commodity = await this.$tkParse.getList(`/classes/commodity`, { params: { where: { objectId: this.commodityId } } })
      this.commodity = commodity[0]
      if (!this.commodity.collection) { this.commodity.collection = [] }
      if (this.commodity.typeActivity === 'panicBuying' && this.judgeTimeRule) { // 限时抢购价格处理
        if (this.isTerminalAccount) {
          this.commodity.price = this.commodity.activityTerminalPrice
          this.commodity.oldPrice = this.commodity.terminalPrice
        } else {
          this.commodity.price = this.commodity.activityCountyPrice
          this.commodity.oldPrice = this.commodity.countyPrice
        }
      } else if (this.commodity.typeActivity === 'promotions') {
        if (this.isTerminalAccount) {
          this.commodity.price = this.commodity.activityTerminalPrice
          this.commodity.oldPrice = this.commodity.terminalPrice
        } else {
          this.commodity.price = this.commodity.activityCountyPrice
          this.commodity.oldPrice = this.commodity.countyPrice
        }
      } else {
        if (this.isTerminalAccount) {
          this.commodity.price = this.commodity.terminalPrice
        } else {
          this.commodity.price = this.commodity.countyPrice
        }
      }
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/3/20
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let startTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/startTime').catch(e => {
        return { data: null }
      })
      let endTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/endTime').catch(e => {
        return { data: null }
      })
      // 判断时间是否存在
      if (!startTime.data || !endTime.data) {
        this.timeRule = null
        return
      }
      let startSum = new Date(startTime.data).getTime()
      let nowSum = new Date(isoStartDate).getTime()
      if (nowSum <= startSum) {
        this.timeRule = null
        return
      }
      this.timeRule = {
        startTime: startTime.data,
        endTime: endTime.data
      }
    },
    /**
    * 获取购物车数据
    * @date: 2020/4/1
    */
    async getShoppingCart () {
      let shoppingCart = await this.$tkParse.getList('/classes/shoppingCart', {
        params: {
          limit: 1,
          where: {
            user: this.userInfo.objectId
          }
        }
      })
      if (shoppingCart.length) { this.shoppingCart = shoppingCart[0] } else { this.shoppingCart = null }
    },
    /**
    * 获取用户收货地址信息
    * @date: 2020/4/28
    */
    async getUserAddress () {
      if (this.addressId && await this.judgeId(this.addressId, 'shippingAddress')) {
        this.selectedAddress = await this.$tkParse.getData(`/classes/shippingAddress/${this.addressId}`)
        return
      }
      let address = await this.$tkParse.getList('/classes/shippingAddress', { params: {
        limit: 1,
        where: { user: this.userInfo.objectId, default: 'yes' }
      } })
      if (address.length) {
        this.selectedAddress = address[0]
        this.$store.commit('setAddressId', address[0].objectId)
      } else {
        this.selectedAddress = null
        this.$store.commit('setAddressId', null)
      }
    },
    /**
     * 为你推荐数据获取
     * @date: 2020/3/24
     */
    async recommendedProducts (page, next) {
      let commodityData = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-sales',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      this.recommendedProductsData = [...this.recommendedProductsData, ...commodityData]
      if (commodityData.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
    * 跳转到限时抢购页面
    * @date: 2020/4/28
    */
    nextLimitedPage () {
      this.$cleanHistory()
      this.$replace('/commodity/limitedTimeSnapping')
    },
    /**
     * 工具转换
     * @date: 2020/4/10
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    },
    /**
    * 减法计数
    * @date: 2020/3/27
    */
    countLess () {
      if (this.numberOrders <= 1) { return }
      this.numberOrders--
    },
    /**
    * 加法计数
    * @date: 2020/3/27
    */
    countAdd () {
      if (this.numberOrders > this.commodity.inventory) { return }
      this.numberOrders++
    },
    /**
    * 底部加入购物车按钮
    * @date: 2020/3/27
    */
    shoppingCarBtn () {
      // this.numberOrders = 1
      this.selectedShow = true
      this.selectedTips = 'shoppingCar'
    },
    /**
    * 底部立即购买按钮
    * @date: 2020/3/27
    */
    buyNowBtn () {
      // this.numberOrders = 1
      this.selectedShow = true
      this.selectedTips = 'goSettlement'
    },
    /**
    * 关闭弹框
    * @date: 2020/3/27
    */
    closeSelected () {
      // this.numberOrders = 1
      this.selectedTips = 'shoppingCar'
      this.selectedShow = false
    },
    /**
    * 收藏商品
    * @date: 2020/3/30
    */
    async favoriteProduct () {
      if (!this.commodity) { return this.$tkGlobal.toast.add('该商品不存在') }
      if (!await this.judgeId(this.commodity.objectId, 'commodity')) {
        return this.$tkGlobal.toast.add('该商品可能已被删除')
      }
      if (this.collectionDisable) { return this.$tkGlobal.toast.add('您点的太快了') }
      this.collectionDisable = true
      // 数据
      if (!this.commodity.collection.includes(this.userInfo.objectId)) { // 收藏
        if (!this.commodity.collection) { this.commodity.collection = [] }
        this.commodity.collection.push(this.userInfo.objectId)
        await this.$tkParse.put(`/classes/commodity/${this.commodity.objectId}`, { collection: this.commodity.collection })
        this.$tkGlobal.toast.add('收藏成功')
        setTimeout(() => { this.collectionDisable = false }, 500)
        this.$forceUpdate()
        return
      }
      // 取消收藏
      let findIndex = this.commodity.collection.findIndex(s => { return s === this.userInfo.objectId })
      this.commodity.collection.splice(findIndex, 1)
      await this.$tkParse.put(`/classes/commodity/${this.commodity.objectId}`, { collection: this.commodity.collection })
      this.$tkGlobal.toast.add('取消成功')
      setTimeout(() => { this.collectionDisable = false }, 500)
      this.$forceUpdate()
    },
    /**
    * 购物车
    * @date: 2020/4/8
    */
    goShoppingCar () {
      this.$cleanHistory()
      this.$replace('/home/shoppingCar')
    },
    /**
    * 购物车数据处理
    * @date: 2020/4/1
    */
    async shoppingCartData (commodity, businessData) {
      if (this.shoppingCart) { // 购物车有数据
        let data = this.$tkHelper.deepClone(this.shoppingCart.data)
        if (data === 0) { data = [] }
        let findIndex = data.findIndex(s => { return s.merchants.objectId === businessData.objectId }) // 找相同的商家
        // 没有符合商家处理
        if (findIndex === -1) {
          data.unshift({ merchants: businessData, commodityData: [this.commodity] })
        } else { // 有符合商家处理
          let findData = data[findIndex]
          if (!findData.commodityData) { findData.commodityData = [] }
          if (findData.commodityData.length) {
            let findCommodityIndex = findData.commodityData.findIndex(s => { return this.commodity.objectId === s.objectId })
            if (findCommodityIndex === -1) { // 没有符合的商品
              findData.commodityData.unshift(this.commodity)
              data[findIndex] = findData
            } else { // 有符合的商品
              let findCommodityData = findData.commodityData[findCommodityIndex]
              findCommodityData.numberOrders = findCommodityData.numberOrders + this.commodity.numberOrders
              findData.commodityData[findCommodityIndex] = findCommodityData
              data[findIndex] = findData
            }
          } else {
            findData.commodityData.push(this.commodity)
          }
        }
        // 修改购物车数据
        await this.$tkParse.put(`/classes/shoppingCart/${this.shoppingCart.objectId}`, {
          data: data
        })
      } else { // 购物车没有数据
        await this.$tkParse.post('/classes/shoppingCart', {
          user: this.userInfo.objectId,
          data: [{ merchants: businessData, commodityData: [this.commodity] }]
        })
      }
    },
    /**
    * 确定加入购物车或立即购买
    * @date: 2020/3/27
    */
    async sureSelected () {
      let commodity = await this.$tkParse.getData(`/classes/commodity/${this.commodity.objectId}`)
      if (commodity.typeActivity && commodity.typeActivity === 'panicBuying') {
        if (!commodity.snappingInventory) { commodity.snappingInventory = 0 }
        if (!commodity.snappingSales) { commodity.snappingSales = 0 }
        if (commodity.snappingInventory - commodity.snappingSales <= 0) {
          return this.$tkGlobal.toast.add('商品库存不够了')
        }
      }
      this.commodity.numberOrders = this.numberOrders
      if (this.selectedTips === 'shoppingCar') { // 加入购物车
        this.status = 'waiting'
        await this.shoppingCartData(this.commodity, this.businessData).catch(e => {
          throw this.$tkGlobal.toast.add('加入购物车失败')
        })
        this.$tkGlobal.toast.add('成功添加购物车')
        await this.getShoppingCart()
        this.$store.commit('setShoppingSum', this.shoppingCartNum)
        this.status = false
      } else { // 去结算跳到确认订单页
        this.$store.commit('setSelectedData', [{ merchants: this.businessData, commodityData: [this.commodity] }])
        this.$push({ path: '/order/orderConfirmation', query: { type: 'single', id: null } })
      }
      this.selectedShow = false
    }
  }
}
</script>

<style scoped lang="scss">
  /*头部收藏样式*/
  .flex-icon {
    width: 30px;
    height: 30px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
  }
  /*商品标题·销量·价格*/
  .commodity-title {
    background: #fff;
    .commodity-title-active {
      width: 205px;
      /*min-height: 22px;*/
      text-align: center;
      border: 1px solid rgba(233, 221, 221, 1);
      padding: 2px 3px;
      border-radius: 11px;
      font-size: 13px;
      color: rgba(250, 51, 51, 1);
    }
    .commodity-title-activePrice {
      min-height: 64px;
      background:linear-gradient(90deg,rgba(255,56,67,1),rgba(254,102,0,1));
      color: #fff;
      .commodity-title-decoration {
        text-decoration: line-through;
      }
    }
    .commodity-title-price {
      color: rgba(250, 51, 51, 1);
      font-weight: bold;
      font-size: 15px;
      .commodity-title-decoration {
        text-decoration: line-through;
      }
    }
  }
  /*优惠券样式*/
  .commodity-vouchers {
    min-height: 20px;
    border-bottom: 1px solid #f5f5f5;
    .commodity-vouchers-style {
      text-align: center;
      width: 78px;
      height: 20px;
      background-color: rgba(255, 233, 236, 1);
      border-radius: 3px;
      line-height: 20px;
      font-size: 12px;
      color: rgba(250, 51, 51, 1);
    }
  }
  /*v-html图片样式*/
  .commodity-detail-color {
    ::v-deep img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
      object-fit: cover;
      overflow: hidden;
    }
  }
  /*已选弹框样式*/
  .selected-style {
    width: 100vw;
    min-height: 126px;
    background-color: rgba(255, 255, 255, 1);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    /*图片样式*/
    .selected-style-image {
      overflow: hidden;
      border-radius: 5px;
      width: 105px;
      height: 105px;
    }
    /*价格样式*/
    .selected-style-price {
      color: rgba(250, 51, 51, 1);
      .selected-style-decoration {
        text-decoration: line-through;
      }
    }
    /*计数样式*/
    .selected-style-count {
      min-width: 119px;
      height: 29px;
      border: 2px solid rgba(245, 245, 245, 1);
      border-radius: 15px;
      .selected-style-count-left {
        width: 40px;
      }
      .selected-style-count-center {
        width: 40px;
        text-align: center;
        line-height: 24px;
        border-right: 2px solid rgba(245, 245, 245, 1);
        border-left: 2px solid rgba(245, 245, 245, 1);
      }
      .selected-style-count-right {
        width: 40px;
      }
    }
  }
  /*底部样式*/
  .footer-card-btn {
    width: 210px;
    height: 36px;
    border-radius: 18px;
    color: #fff;
    .footer-card-btn-lt {
      background-color: #DCB353;
      width: 105px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border-top-left-radius: 18px;
      border-bottom-left-radius: 18px;
    }
    .footer-card-btn-rt {
      background-color: rgba(207, 22, 19, 1);
      width: 105px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border-top-right-radius: 18px;
      border-bottom-right-radius: 18px;
    }
  }
  ::v-deep .tk-container-content .tk-container-cover {
    z-index: 105 !important;
  }

</style>
